module.exports = __webpack_public_path__ + "img/footer_logo.38040a20.png";